import type { ChildrenProps } from "../types";

export function DataGridRow({ children }: ChildrenProps) {
	/** Render */
	return children;
}
